import React from "react";
import { Avatar, Divider } from "antd";
import iconDown from "images/icon-linkedin.svg";

import "./style.scss";
// import PopupSpeakerSummit from "../PopupInstructor";

const CardUser = ({ instructor, title, btnClass = true }) => {
  return (
    <div className={"card-user"}>
      <Avatar src={instructor?.img} size={150}></Avatar>
      <Divider className={"divider"} />
      <h3 className={"name"}>{`${instructor?.firstName} ${instructor?.lastName ? instructor?.lastName : ''}`}</h3>
      <p style={{ fontSize: "15px" }}>{instructor?.titleProfessions}</p>

          <div className={"container"}>
            <a href={instructor?.personalLinks?.linkedin || instructor?.linkedin || '#'} target="_blank" rel="noopener noreferrer">
              <img className={"icon-linkedin"} src={iconDown} alt="linkedin" />
        </a>
        </div>
    </div>
  );
};

export default CardUser;
